import {
	type ProjectType,
	SERVICE_DESK_PROJECT,
	CUSTOMER_SERVICE_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import { useProjectProperties } from '@jira/platform__services-project-properties/src/services/index.tsx';

//
// M3 helpers
// ---------------------

export const isJCSProjectType = (projectType: string | null | undefined): boolean =>
	projectType === CUSTOMER_SERVICE_PROJECT;

export const isJSMorJCSProjectType = (projectType: string | null | undefined): boolean =>
	projectType === SERVICE_DESK_PROJECT || isJCSProjectType(projectType);

export const useIsJCSProjectType: (
	projectType: ProjectType | string | null | undefined,
) => boolean = (projectType) => isJCSProjectType(projectType);

//
//  M2 helpers, deprecated
// ---------------------

/**
 * @deprecated use useIsJCSProjectType instead
 */
export const useIsJCS = (): boolean => {
	const { 'initial.project.template.name': initialProjectTemplate } = useProjectProperties([
		'initial.project.template.name',
	]);

	return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
};

/**
 * @deprecated use isJCSProjectType instead
 */
export const isJCSTemplate: (
	template: string | undefined,
) => template is 'com.atlassian.jcs:customer-service-management' = (template) =>
	template === 'com.atlassian.jcs:customer-service-management';
